import { Copy } from "lucide-react";
import { COMPANY } from "@/lib/brand";
import { copyText } from "@/components/brand/ColourSwatch";

const ROWS = [
  ["Legal name", COMPANY.legal],
  ["Trading name", COMPANY.trading],
  ["ABN", COMPANY.abn],
  ["ACN", COMPANY.acn],
  ["Registered office", COMPANY.office],
  ["Tagline", COMPANY.tagline],
];

export const CompanyDetails = () => (
  <div className="rounded-[28px] border border-sky-100 bg-white p-2 sm:p-4" data-testid="brand-company">
    <dl className="divide-y divide-sky-100">
      {ROWS.map(([k, v]) => (
        <div key={k} className="flex flex-col gap-1 px-4 py-3 sm:flex-row sm:items-center sm:gap-6">
          <dt className="w-44 shrink-0 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">{k}</dt>
          <dd className="flex min-w-0 flex-1 items-center justify-between gap-3 text-sm text-ink">
            <span className="break-words" data-testid={`brand-company-${k.toLowerCase().replace(/\s+/g, "-")}`}>{v}</span>
            <button onClick={() => copyText(v, k)} className="shrink-0 rounded-full p-2 text-slate-500 hover:bg-sky-50 hover:text-sky-700" aria-label={`Copy ${k}`} data-testid={`brand-company-copy-${k.toLowerCase().replace(/\s+/g, "-")}`}><Copy className="h-4 w-4" /></button>
          </dd>
        </div>
      ))}
    </dl>
  </div>
);

const RULES = [
  ["Clear space", "Keep empty space around the logo at least half the height of the icon."],
  ["Minimum size", "Full logo 30 mm wide; icon on its own 8 mm wide."],
  ["Backgrounds", "Primary logo on white or light colours, reversed logo on navy or dark photos."],
  ["Don't", "Stretch, rotate, recolour, outline, add shadows or rebuild the lettering."],
];

export const LogoRules = () => (
  <div className="grid gap-3 sm:grid-cols-2" data-testid="brand-logo-rules">
    {RULES.map(([k, v]) => (
      <div key={k} className="rounded-3xl bg-[#F4F9FD] p-5">
        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-sky-700">{k}</p>
        <p className="mt-1.5 text-sm text-slate-700">{v}</p>
      </div>
    ))}
  </div>
);
